import { render, staticRenderFns } from "./Newses.vue?vue&type=template&id=0e96c4aa&scoped=true&"
import script from "./Newses.vue?vue&type=script&lang=js&"
export * from "./Newses.vue?vue&type=script&lang=js&"
import style0 from "./Newses.vue?vue&type=style&index=0&id=0e96c4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96c4aa",
  null
  
)

export default component.exports